import axios from "axios"
import Cookies from "js-cookie"
export default {
  data() {
    return {
      main_page_switch: false,
    }
  },
  methods: {
    /**
     * 搜尋 JSON 資料，根據指定條件過濾。
     * @param {Array} data - 要過濾的資料陣列。
     * @param {Object} [searchCriteria={}] - 搜尋條件，預設為空物件（返回所有資料）。
     * @returns {Array} 過濾後的資料。
     */
    searchJson: function (data, searchCriteria = {}) {
      // 輸入驗證
      if (!Array.isArray(data)) {
        return []
      }
      if (typeof searchCriteria !== "object" || searchCriteria === null) {
        return data
      }

      // 限制資料規模
      const MAX_DATA_SIZE = 10000
      if (data.length > MAX_DATA_SIZE) {
        console.warn(`Large dataset detected (${data.length} > ${MAX_DATA_SIZE}), consider pagination.`)
        return data.slice(0, MAX_DATA_SIZE)
      }

      // 限制搜尋條件數量
      const MAX_CRITERIA_COUNT = 50
      if (Object.keys(searchCriteria).length > MAX_CRITERIA_COUNT) {
        console.warn(`Too many search criteria (${Object.keys(searchCriteria).length} > ${MAX_CRITERIA_COUNT}).`)
        return []
      }

      // 如果 searchCriteria 為空，返回所有資料
      if (Object.keys(searchCriteria).length === 0) {
        return data
      }

      // 檢查鍵型別
      if (Object.keys(searchCriteria).some((k) => typeof k !== "string")) {
        console.warn("Non-string keys detected in searchCriteria.")
        return []
      }

      // 定義允許的頂層鍵
      const ALLOWED_TOP_LEVEL_KEYS = ["open_d", "close_d", "show_to_index", "ref", "banner_color"]

      try {
        return data.filter((item) => {
          if (!item || typeof item !== "object" || Object.keys(item).length > 100) {
            return false
          }

          return Object.keys(searchCriteria).every((key) => {
            // 防止不安全鍵
            if (key === "__proto__" || key === "constructor") {
              return false
            }

            // 處理 content 屬性
            if (key.startsWith("content.")) {
              const MAX_CONTENT_KEY_LENGTH = 50
              const CONTENT_KEY_REGEX = /^content\.[a-zA-Z0-9_]+$/
              if (key.length > MAX_CONTENT_KEY_LENGTH || !CONTENT_KEY_REGEX.test(key)) {
                console.warn(`Invalid content key: ${key}`)
                return false
              }
              const contentKey = key.split(".")[1]
              if (!contentKey || contentKey === "__proto__" || contentKey === "constructor" || !item.content || typeof item.content !== "object" || !Object.prototype.hasOwnProperty.call(item.content, contentKey)) {
                console.debug(`Invalid item.content for key: ${key}`)
                return false
              }

              const searchValue = searchCriteria[key]
              const itemValue = item.content[contentKey]

              if (Array.isArray(itemValue) && Array.isArray(searchValue)) {
                const MAX_ARRAY_LENGTH_ITEM = 1000
                const MAX_ARRAY_LENGTH_SEARCH = 100
                if (itemValue.length > MAX_ARRAY_LENGTH_ITEM || searchValue.length > MAX_ARRAY_LENGTH_SEARCH) {
                  return false
                }
                if (!itemValue.every((val) => typeof val === "string") || !searchValue.every((val) => typeof val === "string")) {
                  return false
                }
                return searchValue.every((val) => itemValue.includes(val))
              }
              return itemValue === searchValue
            }

            // 限制允許的頂層鍵
            if (!ALLOWED_TOP_LEVEL_KEYS.includes(key)) {
              console.warn(`Invalid key: ${key}. Allowed keys are: ${ALLOWED_TOP_LEVEL_KEYS.join(", ")}`)
              return false
            }

            // 處理日期範圍搜尋
            if (key === "open_d" || key === "close_d") {
              if (!Object.prototype.hasOwnProperty.call(item, key) || typeof searchCriteria[key] !== "string") {
                return false
              }
              const searchDate = new Date(searchCriteria[key])
              const itemDate = new Date(item[key])
              if (isNaN(searchDate.getTime()) || isNaN(itemDate.getTime())) {
                return false
              }
              return searchDate.getTime() <= itemDate.getTime()
            }

            // 一般字串搜尋 (精確匹配)
            if (Object.prototype.hasOwnProperty.call(item, key) && typeof item[key] === "string" && typeof searchCriteria[key] === "string") {
              const MAX_STRING_LENGTH = 10000
              if (item[key].length > MAX_STRING_LENGTH || searchCriteria[key].length > MAX_STRING_LENGTH) {
                return false
              }
              return item[key] === searchCriteria[key] // 改為精確匹配
            }

            // 精確匹配 (其他型別)
            return Object.prototype.hasOwnProperty.call(item, key) && item[key] === searchCriteria[key]
          })
        })
      } catch (error) {
        console.error("Error in searchJson:", error) // 避免洩漏 searchCriteria
        return []
      }
    },
    checkLoginTokeVaild(login_token) {
      const me = this
      const json_d = { token: login_token }

      axios({
        method: "POST",
        url: `${me.$apiUrl2}checkLoginTokeVaild`,
        data: json_d,
        headers: {
          Authorization: `Bearer 76s6hBdR594llBaEBNtP`,
          "Content-Type": "application/json",
        },
      }).then(function (response) {
        const res = response.data

        if (res.status === 201) {
          if (res.statusText === "Select") {
            me.user_uuid = res.data.id
            sessionStorage.setItem("uuid", res.data.id)
            sessionStorage.setItem("is_used", res.data.user_take.is_used)
            sessionStorage.setItem("is_email_confirm", res.data.user_take.is_email_confirm)
            Cookies.set("uuid", res.data.id, { secure: true })
            Cookies.set("is_used", res.data.user_take.is_used, { secure: true })
            Cookies.set("is_email_confirm", res.data.user_take.is_email_confirm, { secure: true })
            // if (me.$route.name === "login") {
            // window.location.href = `/Subscribe?id=${res.data.id}&op=notify_manage`
            // }
          }
        }
        if (res.status === 503) {
          me.main_page_switch = false
          me.user_uuid = null
          // window.location.href = `/Login`
        }
      })
    },
  },
}
